import moment from 'moment'
import config from './config';

moment.locale(config.MOMENT_LOCALE)

export default moment
